// extracted by mini-css-extract-plugin
export default {"Label":"Date_Label__IUS5L","Input":"Date_Input__qCaVN"};